import { Formik, FormikHelpers } from "formik";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { EMAIL_SENT } from "@src/common/helpers/toastIds";
import RegisterFormContent from "@src/modules/Public/Register/RegisterFormContent";
import useRegister, {
  RegisterModel,
} from "@src/modules/Public/Register/useRegister";

const initialValues: RegisterModel = {
  userName: "",
  email: "",
  password: "",
  policyChecked: false,
};

const RegisterForm: FunctionComponent = () => {
  const mutation = useRegister();
  const { t } = useTranslation();

  const validationSchema: Yup.SchemaOf<RegisterModel> = Yup.object().shape({
    userName: Yup.string().required(t("Names required")),
    email: Yup.string()
      .email(t("Invalid e-mail"))
      .required(t("E-mail required")),
    password: Yup.string()
      .min(6, t("Too short!"))
      .max(100, t("Too long!"))
      .required(t("Password required")),
    policyChecked: Yup.bool()
      .oneOf([true], t("Must accept terms and conditions"))
      .required(),
  });

  const handleSubmit = async (
    values: RegisterModel,
    { resetForm, setSubmitting }: FormikHelpers<RegisterModel>,
  ) =>
    mutation.mutate(values, {
      onSuccess: () => {
        toast.success(t("Check your inbox, we send you activation link"), {
          toastId: EMAIL_SENT,
        });
        resetForm();
      },
      onSettled: () => setSubmitting(false),
    });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formProps) => (
        <RegisterFormContent {...formProps} isLoading={mutation.isLoading} />
      )}
    </Formik>
  );
};

export default RegisterForm;
